import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

export const verifyAdminEmail = async (email) => {
  const q = query(
    collection(db, "users"),
    where("email", "==", email)
  );

  const snap = await getDocs(q);

  if (snap.empty) {
    throw new Error("Admin account not found");
  }

  const user = snap.docs[0].data();

  if (user.role !== "admin") {
    throw new Error("Not an admin");
  }

  return true;
};
